import { Helmet } from "react-helmet";
import { Redirect, useHistory, useLocation } from "react-router";
import Layout from "../../components/Layout";
import LayoutCard from "../../components/LayoutCard";
import { Heading, Text } from "../../components/Type";
import Button from "../../components/Button";
import { ArrowRight } from "../../components/Icons/general-interface-1";
import styles from "./index.module.scss";
import { useStoreContext } from "../../contexts/StoreProvider";

const Logout = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const {
    state: { authenticated },
  } = useStoreContext();

  if (authenticated) {
    // In case e.g. refreshing this page after logging in in another tab
    return <Redirect to="/" />;
  }
  return (
    <Layout>
      <Helmet>
        <title>Motion Logout</title>
      </Helmet>
      <LayoutCard header={<Heading size="h4">Log out successful</Heading>}>
        <Text>
          {pathname === "/timeout"
            ? "Your session expired and you were logged out due to inactivity."
            : "You have successfully logged out."}
        </Text>
        <div className={styles.buttonRow}>
          <Button
            primary
            icon={<ArrowRight />}
            onClick={() => history.push("/login")}
          >
            Log back in
          </Button>
        </div>
      </LayoutCard>
    </Layout>
  );
};

export default Logout;
